const actions = {
    REJECT_DETAILS_START: 'REJECT_DETAILS_START',
    REJECT_DETAILS_SUCCESS: 'REJECT_DETAILS_SUCCESS',
    REJECT_DETAILS_FAILURE: 'REJECT_DETAILS_FAILURE',

    TAX_TYPE_START: 'TAX_TYPE_START',
    TAX_TYPE_SUCCESS: 'TAX_TYPE_SUCCESS',
    TAX_TYPE_FAILURE: 'TAX_TYPE_FAILURE',

    WORKFLOW_START: 'WORKFLOW_START',
    WORKFLOW_SUCCESS: 'WORKFLOW_SUCCESS',
    WORKFLOW_FAILURE: 'WORKFLOW_FAILURE',

    FREQUENCY_START: 'FREQUENCY_START',
    FREQUENCY_SUCCESS: 'FREQUENCY_SUCCESS',
    FREQUENCY_FAILURE: 'FREQUENCY_FAILURE',

    CLEAR_SETUP_START: 'CLEAR_SETUP_START',
    CLEAR_SETUP_SUCCESS: 'CLEAR_SETUP_SUCCESS'
};

export default actions;